import React from "react";

import {
  Link,
} from "react-router-dom";

import {
  FaArrowDown,
  FaFileInvoiceDollar,
  FaChartBar,
  FaChevronRight,
} from "react-icons/fa";

import peaje from "../images/peaje.png";

import Footer from "../components/Footer";

import "../css/home.css";
import "../css/footer.css";

const items = [
  {
    to: "/importarpeajes",
    icon: FaArrowDown,
    titulo: "Importar consumos",
    descripcion:
      "Carga de consumos de TelePASE y Telepeaje Plus",
  },

  {
    to: "/resumenespeajes",
    icon: FaFileInvoiceDollar,
    titulo: "Resúmenes y pagos",
    descripcion:
      "Facturación, conciliación y gestión de pagos",
  },

  {
    to: "/informepeajes",
    icon: FaChartBar,
    titulo: "Informe de peajes",
    descripcion:
      "Consulta, análisis y exportación de consumos",
  },
];

const HomePeajes = () => {
  return (
    <>
      <main className="danlu-subhome">
        {/* CABECERA */}

        <section className="danlu-subhome-hero peajes">
          <div className="danlu-subhome-main-icon">
            <img
              src={peaje}
              alt="Peajes"
            />
          </div>

          <div className="danlu-subhome-title">
            <span>
              MÓDULO
            </span>

            <h1>
              Gestión de Peajes
            </h1>

            <p>
              Consumos, facturación,
              conciliación y pagos
            </p>
          </div>
        </section>

        {/* OPCIONES */}

        <section className="danlu-subhome-grid">
          {items.map(
            ({
              to,
              icon: Icon,
              titulo,
              descripcion,
            }) => (
              <Link
                key={to}
                to={to}
                className="danlu-subhome-card peajes"
              >
                <div className="danlu-subhome-card-icon">
                  <Icon />
                </div>

                <div className="danlu-subhome-card-body">
                  <h3>
                    {titulo}
                  </h3>

                  <p>
                    {descripcion}
                  </p>
                </div>

                <div className="danlu-subhome-arrow">
                  <FaChevronRight />
                </div>
              </Link>
            )
          )}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HomePeajes;